import Vue from 'vue';
import VueRouter from 'vue-router';

import FTSLogin from "../administration/FTSLogin";
import Client from "../../Client";
import Studio from "../../Studio";
import Admin from "../../Admin";
import Builder from "../../Builder";
import ShareForm from "../../ShareForm";
import FTSDashboard from "../client/FTSDashboard";
import FTSCalendar from "../client/FTSCalendar";
import FTSHtmlViewer from "../client/FTSHtmlViewer";
import FTSListView from "../elements/FTSListView";
import FTSUsers from "../client/FTSUsers";
import FTSLobby from "../client/FTSLobby";
import FTSWorkspaceSetup from "../design/FTSWorkspaceSetup";
import FTSMobileSolution from "../mobile/FTSMobileSolution";
import FTSMobileFlowDiagram from "../mobile/FTSMobileFlowDiagram";
import FTSMobileChart from "../mobile/FTSMobileChart";
import FTSDevicePreview from "../device-preview/FTSDevicePreview";
import External from "../external/External";

import Lite from "../../Lite";
import LiteListView from "../elements/views/FTSListView";
import LiteDevicePreview from "../../components/lite/FTSDevicePreview";
import LiteUsers from "../../components/lite/FTSUsers";
import OnboardingView from "../elements/views/FTSOnboarding.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login/:action?',
    name: 'login',
    component: FTSLogin,
    meta: {
      title: 'Sign in'
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: FTSLogin
  },
  {
    path: '/join',
    name: 'join',
    component: FTSLogin,
  },
  {
    path: '/activate',
    name: 'activate',
    component: FTSLogin,
    meta: {
      title: 'Activation'
    }
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: FTSLogin,
    meta: {
      title: 'Reset password'
    }
  },
  {
    path: '/reset',
    name: 'reset',
    component: FTSLogin,
    meta: {
      title: 'Set new password'
    }
  },
  {
    path: '/createAccount/:action?',
    name: 'createAccount',
    component: FTSLogin,
    meta: {
      title: 'Sign up'
    }
  },
  {
    path: '/setup-workspace',
    name: 'setup-workspace',
    component: FTSWorkspaceSetup,
    meta: {
      title: 'Setup a new workspace',
      requiresAuth: true
    }
  },
  {
    path: '/create-workspace',
    name: 'create-workspace',
    component: FTSWorkspaceSetup,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mobile-solution',
    name: 'mobile-solution',
    component: FTSMobileSolution,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mobile-flow-diagram',
    name: 'mobile-flow-diagram',
    component: FTSMobileFlowDiagram,
    meta: {
      external: true
    }
  },
  {
    path: '/mobile-chart',
    name: 'mobile-chart',
    component: FTSMobileChart,
    meta: {
      external: true
    }
  },
  {
    path: '/preview',
    name: 'device-preview',
    component: FTSDevicePreview,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/external',
    name: 'external',
    component: External,
    meta: {
      external: true,
      requiresAuth: true
    }
  },
  {
    path: '/client',
    name: 'client',
    component: Client,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: FTSDashboard,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/calendar',
        name: 'calendar',
        component: FTSCalendar,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/htmlViewer',
        name: 'htmlViewer',
        component: FTSHtmlViewer,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/list/:moduleId',
        name: 'list-view',
        component: FTSListView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/users',
        name: 'users',
        component: FTSUsers,
        meta: {
          requiresAuth: true,
          group: "users"
        }
      },
      {
        path: '/users/inactive',
        name: 'users-inactive',
        component: FTSUsers,
        meta: {
          requiresAuth: true,
          group: "users"
        }
      },
      {
        path: '/users/invitation',
        name: 'users-invitation',
        component: FTSUsers,
        meta: {
          requiresAuth: true,
          group: "users"
        }
      },
      {
        path: '/users/lobby',
        name: 'users-lobby',
        component: FTSUsers,
        meta: {
          requiresAuth: true,
          group: "users"
        }
      },
      {
        path: '/lobby',
        name: 'lobby',
        component: FTSLobby,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/client',
        redirect: '/dashboard'
      }
    ]
  },
  {
    path: '/studio',
    name: 'studio',
    component: Studio,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/builder',
    name: 'builder',
    component: Builder,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/lite-home',
    name: 'lite-home',
    component: Lite,
    children: [
      {
        path: '/lite/:moduleId?/',
        name: 'lite',
        component: LiteListView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/lite/studio/:moduleId?/',
        name: 'lite-studio',
        component: LiteListView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/lite/preview',
        name: 'lite-preview',
        component: LiteDevicePreview,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/lite-users',
        name: 'lite-users',
        component: LiteUsers,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/lite-home',
        redirect: '/lite'
      }
    ]
  },
  {
    path: '/share/:id?',
    name: 'shareForm',
    component: ShareForm,
  },
  {
    path: "/onboarding",
    name: "onboarding",
    component: OnboardingView,
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

/* avoided redundant navigation to current location (NavigationDuplicated) */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default routes;